// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*\n* Corestream Variables\n* Copyright 2019 Corestream\n*/\n/*\n * Corestream Mixins\n * Copyright 2019 Corestream\n */\n@supports (-ms-ime-align: auto) and (-webkit-text-stroke: initial) {\n  body .cs-sidebar .cs-menu-dropdown .cs-menu-dropdown--navigation .cs-menu-dropdown--navigation__item {\n    -ms-flex-preferred-size: 0%;\n        flex-basis: 0%;\n  }\n  .cs-popdown-list .cs-list--item {\n    -ms-flex-preferred-size: 0%;\n        flex-basis: 0%;\n  }\n}", ""]);
// Exports
module.exports = exports;
